import ArtLamp from '../../src/legacy/ArtLamp.tsx';
export default ArtLamp;
